/* Candidate: enrich one native Shopify block, without requests or storefront events. */
(function () {
  'use strict';
  function enrich(original, facts, base) {
    if (!original || original['@type'] !== 'ProductGroup' || !facts ||
        !Array.isArray(facts.variants) || !Array.isArray(original.hasVariant) ||
        !original.hasVariant.length || facts.variants.length > 250) return null;
    const origin = new URL(base);
    const group = new URL(original['@id'], origin);
    if (group.origin !== origin.origin || group.pathname !== facts.path || group.hash !== '#product') return null;
    const source = new Map();
    for (const row of facts.variants) {
      if (!row || !/^\d+$/.test(row.id) || source.has(row.id)) return null;
      for (const key of Object.keys(row)) {
        if (!['id', 'size', 'color'].includes(key)) return null;
        if (typeof row[key] !== 'string' || !row[key].trim() || row[key].length > 200) return null;
      }
      source.set(row.id, row);
    }
    const result = JSON.parse(JSON.stringify(original));
    const dimensions = new Set();
    const seen = new Set();
    for (const variant of result.hasVariant) {
      if (variant['@type'] !== 'Product') return null;
      const identity = new URL(variant['@id'], origin);
      const id = identity.searchParams.get('variant');
      if (identity.origin !== origin.origin || identity.pathname !== facts.path ||
          identity.hash !== '#variant' || !source.has(id) || seen.has(id)) return null;
      seen.add(id);
      for (const key of ['size', 'color']) {
        const value = source.get(id)[key];
        if (value === undefined) continue;
        if (variant[key] !== undefined && variant[key] !== value) return null;
        variant[key] = value;
        dimensions.add('https://schema.org/' + key);
      }
    }
    if (!dimensions.size) return null;
    const existing = result.variesBy === undefined ? [] :
      (Array.isArray(result.variesBy) ? result.variesBy : [result.variesBy]);
    if (existing.some(value => typeof value !== 'string' || !value.startsWith('https://schema.org/'))) return null;
    result.variesBy = [...new Set([...existing, ...dimensions])];
    return result;
  }
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { enrich };
    return;
  }
  try {
    const nodes = document.querySelectorAll('#SapiatoNativeProductSchema');
    const facts = document.querySelectorAll('#SapiatoVariantSchemaFacts');
    if (nodes.length !== 1 || facts.length !== 1) return;
    const result = enrich(JSON.parse(nodes[0].textContent), JSON.parse(facts[0].textContent), location.href);
    if (result) nodes[0].textContent = JSON.stringify(result).replace(/</g, '\\u003c');
  } catch (_) {
    // Preserve Shopify's native block on any unsupported shape or ambiguity.
  }
}());
